const c = ":host{display:block;position:relative}.sl-select-button{display:flex;height:2.25rem;width:100%;align-items:center;justify-content:space-between;border-radius:var(--sl-radius-md);border:1px solid hsl(var(--sl-hsl-border));background-color:hsl(var(--sl-hsl-input));color:hsl(var(--sl-hsl-foreground));padding:0 var(--sl-spacing-3);font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm);outline:none;cursor:pointer;transition:border-color var(--sl-transition-fast),box-shadow var(--sl-transition-fast);box-sizing:border-box}.sl-select-button:hover:not(.sl-select-button--disabled){border-color:hsl(var(--sl-hsl-primary-200))}.sl-select-button:focus{border-color:hsl(var(--sl-hsl-primary));box-shadow:0 0 0 2px hsl(var(--sl-hsl-background)),0 0 0 4px hsl(var(--sl-hsl-ring))}.sl-select-button--disabled{cursor:not-allowed;opacity:0.5}.sl-select-value{flex:1;text-align:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sl-select-value--placeholder{color:hsl(var(--sl-hsl-muted-foreground))}.sl-select-icon{width:1rem;height:1rem;opacity:0.5;flex-shrink:0;margin-left:var(--sl-spacing-2);transition:transform var(--sl-transition-fast)}.sl-select-icon--open{transform:rotate(180deg)}.sl-select-dropdown{position:absolute;top:calc(100% + 0.25rem);left:0;right:0;z-index:50;max-height:min(15rem,40vh);max-height:min(15rem,40dvh);overflow-y:auto;border-radius:var(--sl-radius-md);border:1px solid hsl(var(--sl-hsl-border));background-color:hsl(var(--sl-hsl-popover));color:hsl(var(--sl-hsl-popover-foreground));box-shadow:var(--sl-shadow-lg);animation:sl-select-fade-in 0.15s ease-out;margin:0;padding:0}.sl-select-dropdown:popover-open{position:fixed;inset:auto}.sl-select-options{padding:var(--sl-spacing-1)}.sl-select-option{display:flex;width:100%;cursor:pointer;user-select:none;align-items:center;border-radius:var(--sl-radius-sm);padding:var(--sl-spacing-2) var(--sl-spacing-3);font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm);outline:none;transition:background-color var(--sl-transition-fast);box-sizing:border-box}.sl-select-option:hover:not(.sl-select-option--disabled){background-color:hsl(var(--sl-hsl-secondary));color:hsl(var(--sl-hsl-secondary-foreground))}.sl-select-option--selected{background-color:hsl(var(--sl-hsl-secondary));color:hsl(var(--sl-hsl-secondary-foreground));font-weight:var(--sl-font-weight-medium)}.sl-select-option--disabled{pointer-events:none;opacity:0.5}@keyframes sl-select-fade-in{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:translateY(0)}}";
class u extends HTMLElement {
  constructor() {
    super(), this._isOpen = !1, this._shadow = this.attachShadow({ mode: "open" }), this._handleOutsideClick = this._onOutsideClick.bind(this), this._handleButtonClickBound = this._handleButtonClick.bind(this), this._handleButtonKeydownBound = this._handleButtonKeydown.bind(this), this._handleWindowChangeBound = this._closeDropdown.bind(this), this._render();
  }
  static get observedAttributes() {
    return ["value", "placeholder", "disabled", "options"];
  }
  connectedCallback() {
    document.addEventListener("click", this._handleOutsideClick);
  }
  disconnectedCallback() {
    document.removeEventListener("click", this._handleOutsideClick), this._removeWindowListeners();
  }
  attributeChangedCallback(e, s, t) {
    s !== t && (this._render(), this._isOpen && this._showPopover());
  }
  get value() {
    return this.getAttribute("value") || "";
  }
  set value(e) {
    this.setAttribute("value", e);
  }
  get placeholder() {
    return this.getAttribute("placeholder") || "Select an option...";
  }
  set placeholder(e) {
    this.setAttribute("placeholder", e);
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(e) {
    e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  get options() {
    const e = this.getAttribute("options");
    if (!e) return [];
    try {
      const s = JSON.parse(e);
      return Array.isArray(s) ? s : [];
    } catch {
      return console.warn("[sl-select] Invalid JSON in options attribute"), [];
    }
  }
  set options(e) {
    this.setAttribute("options", JSON.stringify(e));
  }
  _getSelectedLabel() {
    const e = this.options.find((s) => s.value === this.value);
    return e ? e.label : "";
  }
  _onOutsideClick(e) {
    if (!this._isOpen) return;
    e.composedPath().includes(this) || this._closeDropdown();
  }
  _handleButtonClick() {
    this.disabled || (this._isOpen ? this._closeDropdown() : this._openDropdown());
  }
  _handleButtonKeydown(e) {
    e.key === "Enter" || e.key === " " ? (e.preventDefault(), this._handleButtonClick()) : e.key === "Escape" && this._closeDropdown();
  }
  _selectOption(e) {
    e.disabled || (this._closeDropdown(), this.value = e.value, this.dispatchEvent(
      new CustomEvent("change", {
        bubbles: !0,
        composed: !0,
        detail: { value: e.value }
      })
    ));
  }
  _openDropdown() {
    this._isOpen || (this._isOpen = !0, this._render(), this._showPopover(), this._addWindowListeners());
  }
  _closeDropdown() {
    this._isOpen && (this._isOpen = !1, this._removeWindowListeners(), this._render());
  }
  _showPopover() {
    const e = this._shadow.querySelector(".sl-select-dropdown");
    if (e && (this._positionDropdown(e), typeof e.showPopover == "function"))
      try {
        e.matches(":popover-open") || e.showPopover();
      } catch {
      }
  }
  _positionDropdown(e) {
    const s = this._shadow.querySelector(".sl-select-button");
    if (!s) return;
    const t = s.getBoundingClientRect();
    e.style.top = `${t.bottom + 4}px`, e.style.left = `${t.left}px`, e.style.width = `${t.width}px`;
  }
  _addWindowListeners() {
    window.addEventListener("scroll", this._handleWindowChangeBound, !0), window.addEventListener("resize", this._handleWindowChangeBound);
  }
  _removeWindowListeners() {
    window.removeEventListener("scroll", this._handleWindowChangeBound, !0), window.removeEventListener("resize", this._handleWindowChangeBound);
  }
  _render() {
    const e = this._getSelectedLabel(), s = !!e, t = ["sl-select-button"];
    this.disabled && t.push("sl-select-button--disabled");
    const n = ["sl-select-icon"];
    this._isOpen && n.push("sl-select-icon--open");
    const r = ["sl-select-value"];
    s || r.push("sl-select-value--placeholder");
    const d = this._isOpen ? `
      <div class="sl-select-dropdown" popover="manual">
        <div class="sl-select-options">
          ${this.options.map((o) => {
      const i = ["sl-select-option"];
      return o.disabled && i.push("sl-select-option--disabled"), o.value === this.value && i.push("sl-select-option--selected"), `<div class="${i.join(" ")}" data-value="${o.value}">${o.label}</div>`;
    }).join("")}
        </div>
      </div>
    ` : "";
    this._shadow.innerHTML = `
      <style>${c}</style>
      <button
        type="button"
        class="${t.join(" ")}"
        aria-expanded="${this._isOpen}"
        aria-haspopup="listbox"
        ${this.disabled ? "disabled" : ""}
      >
        <span class="${r.join(" ")}">${s ? e : this.placeholder}</span>
        <svg class="${n.join(" ")}" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      ${d}
    `;
    const l = this._shadow.querySelector("button");
    l && (l.addEventListener("click", this._handleButtonClickBound), l.addEventListener("keydown", this._handleButtonKeydownBound)), this._shadow.querySelectorAll(".sl-select-option").forEach((o) => {
      const i = o.dataset.value || "", a = this.options.find((h) => h.value === i);
      a && o.addEventListener("click", () => this._selectOption(a));
    });
  }
}
typeof customElements < "u" && !customElements.get("sl-select") && customElements.define("sl-select", u);
export {
  u as SlSelectElement
};
//# sourceMappingURL=sl-select.js.map
